import React,{useState,useContext}from 'react';
import classes from "./UsersFinder.module.scss";
import Button from "react-bootstrap/Button";
import { validate_alphanumeric_email_symbols  } from '../utils/validator';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../Context/AuthContext';

function UsersFinder(props) {
  const context = useContext(AuthContext);
  const { updateUser,userFinderEna } = props;
  const INPUT_DELAY = 500;
  var last_input_time = 0;
  const [error, setError] = useState("");
  const [inputValue, setInputValue] = useState("");
  const navigate = useNavigate();
  
  const [ isEnable, setIisEnable ] = useState( false );

  function getCurrentTimestamp() {
    return Date.now();
  }

  function get_users( data ){
 
    
    if( data ){
      if( !isEnable )
      {
        setIisEnable( true );
        userFinderEna( true );
      }
    }
    else {
      if( isEnable )
      {
        setIisEnable(  false );
        userFinderEna( false );
      }
    }

    setTimeout(function() {
                                                // your code to be executed after 500 milliseconds
      if( last_input_time + INPUT_DELAY < 
        getCurrentTimestamp() )
        {
          const ob = { 'data':data };
          updateUser( ob );
        }
    }, INPUT_DELAY);
  }


  const handleChange = event => {
    var validInput = false;
    setInputValue( event.target.value );
    try{
      setError("");
      if( event.target.value.length > 2 )
      {
        if( validate_alphanumeric_email_symbols(event.target.value) )validInput = true;
        else setError("Existen caracteres no válidos");
      }
      else if( event.target.value.length === 0 )
      {
        last_input_time = getCurrentTimestamp();
        get_users( null );        
      }
      if(validInput)
      {
        last_input_time = getCurrentTimestamp();
        get_users( event.target.value );
      }
    }catch(e){
      console.log( e );
    }
  };
  

  function newUser(){
    navigate('/newuser');
  }

    return (
        <div className={classes.UsersFinder}>
          <div className={classes.FinderField_0} >Gestión de usuarios</div>
          <div className={classes.FinderOptions}>
            <div className={classes.FinderField_1} >Búsqueda de usuarios</div>

          </div> 

          <div className={classes.FinderCommands}>
            <div className={classes.inputTextContainer}>
              <input value={inputValue} className="form-control"  type="text" id="lname" name="lname" onChange={handleChange}/>
              <div className="text-danger">{error}</div>
            </div>
            <div className="col-sm">
                <Button className='btn' disabled={ context.userInfo.user_level !== '1'?true:false } onClick={newUser}>Nuevo usuario</Button>
              </div>
          </div>

          <div className='row d-flex'>
              
              <div className="col-sm"></div>
          </div>

        </div>  
    ); 
}
export default UsersFinder;
